import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { DialogService } from "../../Shared/dialog.service";
import { ParamMap, Router, ActivatedRoute } from "@angular/router";
declare var $: any;
import { LmsService } from "../../_Lms/services/lms.service";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
@Component({
    selector: 'app-employee-event-config',
    templateUrl: './employee-event-config.component.html',
    styleUrls: ['./employee-event-config.component.scss'],
    standalone: false
})
export class EmployeeEventConfigComponent implements OnInit {
  private _MasterService; 
    data: any;
  showSpinner: boolean = false;
  loading: boolean = false;
    ProductId: any = 0;
      FilterProductId: any = "";
  ProcessDropdown: any = [];
   SelectProductCategory: any = "";
  ProductName: string = "";
  ProductShortName: string = "";
  ProductCategoryDropdown: any = [];
   IsUpdate: boolean = false;
  IsEdit: boolean = false;
  IsDisabled: boolean = false;
  IsDisabledAccount: boolean = false;
  MailTemplateDropdown: any[] = [];
  EventNameDropdown: any[] = [];
  SMS_StepName_Dropdown: any[] = [];
  WhatsAppStepNameDropdown: any[] = [];
  EventConfiguration: any;
  TemplateId: any;
  EventHead: any[] = [];
  EventConfigRows: any[] = [];
  IsSave: boolean = false;
  IsActive_Emp: number;
    // SelectType: any = "";
    SelectType: number | null = null;

    

  Event_Id: any = ""
   configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };


  constructor(
    private dataSharingService: DataSharingService,
    private route: ActivatedRoute,
    private dialog: DialogService,
    private _EncrDecrService: EncrDecrService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private lmsService: LmsService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Employee Template Configuration");
        this.data = JSON.parse(sessionStorage.getItem("currentUser"));
        this.route.paramMap.subscribe((param: ParamMap) => {
          this.FilterProductId = this._EncrDecrService.decrypt(
            decodeURIComponent(param.get("Id"))
          );
                this.getProductDetail();
    
          // if (this.ProductId) {
          //   this.QuickLoan_Get_ProcessLevel();
          // }
        });
        // this.getPageLoad();
        this.GetTemplateList();
        this.Get_EventList();
        this.Get_SMS_StepNameList();
        this.Get_WhatsApp_StepNameList();
        // this.GetEmployeeEventConfiguration(Type);
  }
  getProductCategory() {
      this.MasterService.GetProductCategory().subscribe((result) => {
        this.ProductCategoryDropdown = JSON.parse(JSON.stringify(result));
      });
    }
     getProductDetail() {
      this._MasterService.GetProductListById({ ProductId: this.FilterProductId }).subscribe((result) => {
        if (result.length > 0) {
          this.SelectProductCategory = result[0].ProductCatId;
          this.ProductName = result[0].Product;
          this.ProductShortName = result[0].ShortName;
        }
      });
    }
     QuickLoan_Get_ProcessLevel() {
      this._QuickLoanService
        .QuickLoan_Get_ProcessLevel({ ProductId: this.ProductId })
        .subscribe((res: any) => {
          console.log("res", res);
          this.ProcessDropdown = res;
        });
    }
    GetTemplateList() {
      this.showSpinner = true;
      this.MasterService.Get_Mail_Template({
        IsForCustomer: 0,
      }).subscribe({
        next: (result: any) => {
          this.MailTemplateDropdown = result || [];
          this.showSpinner = false;
          console.log("abc", result);
        },
        error: () => {
          this.showSpinner = false;
        },
      });
    }
    // Get_EventList() {
    //   this.showSpinner = true;
    //   this.MasterService.Get_Employee_Event().subscribe({
    //     next: (result: any) => {
    //       // this.EventNameDropdown = result || [];
    //       this.EventNameDropdown = (result || [])
    //     .filter(x => x.EventFor === 'Employee');
    //       this.showSpinner = false;
          
    //     },
    //     error: () => {
    //       this.showSpinner = false;
    //     },
    //   });
    // }

Get_EventList() {
  this.showSpinner = true;
  this.MasterService.Get_Employee_Event().subscribe({
    next: (result: any) => {
      this.EventNameDropdown = result || [];
      this.showSpinner = false;
    },
    error: () => {
      this.showSpinner = false;
    },
  });
}
getFilteredEventList(index: number) {
  if (this.SelectType === null || this.SelectType === undefined) {
    return [];
  }

  // if (this.SelectType === 1) {
  //   // Process Employee
  //   return this.EventNameDropdown.filter(
  //     x => x.EventFor === 'Employee'
  //   );
  // }

  // if (this.SelectType === 0) {
  //   // Sales Executive
  //   return this.EventNameDropdown.filter(
  //     x => x.EventFor === 'SalesExec'
  //   );
  // }
  

  // return [];
   const eventFor =
    this.SelectType === 1 ? 'Employee' : 'SalesExec';

  const selectedIds = this.getSelectedEventIds(index);

  return this.EventNameDropdown.filter(ev =>
    // 1️⃣ only show events for current dropdown
    ev.EventFor === eventFor &&

    // 2️⃣ do not repeat already configured events
    !selectedIds.includes(Number(ev.Id))
     );
}

    Get_SMS_StepNameList() {
      this.showSpinner = true;
      this.MasterService.Get_SMS_StepName().subscribe({
        next: (result: any) => {
          this.SMS_StepName_Dropdown = result || [];
          this.showSpinner = false;
          console.log("abc", result);
        },
        error: () => {
          this.showSpinner = false;
        },
      });
    }
    Get_WhatsApp_StepNameList() {
      this.showSpinner = true;
      this.MasterService.Get_WhatsApp_StepName().subscribe({
        next: (result: any) => {
          this.WhatsAppStepNameDropdown = result || [];
          this.showSpinner = false;
          console.log("abc", result);
        },
        error: () => {
          this.showSpinner = false;
        },
      });
    }
    
  
    onUpdateSaveEvent(){

      this.saveEventConfig();
    }
    
    GetEmployeeEventConfiguration(type: any) {
      this.SelectType = Number(type);

        this.EventConfigRows.forEach(row => {
          row.Event_Id = null;
        });

    this.MasterService
      .Get_Employee_Event_Configuration({ IsActive_Emp: this.SelectType })
      .subscribe((res: any[]) => {
  
        // 🆕 New product → one empty row
        if (!res || res.length === 0) {
          this.EventConfigRows = [this.createEmptyEventRow()];
          this.IsEdit = false;
          this.IsDisabled = false;
          this.IsUpdate = false;
          this.IsSave = true;
          return;
        }
  
        // Existing configs
        this.EventConfigRows = res.map(obj => ({
          Event_Id: obj.Event_Id,
          ProductId: this.ProductId,
          LoginUserId: this.data.userId,
  
          SMS_Step_Id: obj.SMS_Step_Id ? String(obj.SMS_Step_Id) : "",
          WhatsApp_Step_Id: obj.WhatsApp_Step_Id ? String(obj.WhatsApp_Step_Id) : "",
          Mail_Step_Id: obj.Mail_Step_Id ? String(obj.Mail_Step_Id) : "",
  
          IsSMSActive: obj.IsSMSActive,
          IsEmailActive: obj.IsEmailActive,
          IsWhatsAppActive: obj.IsWhatsAppActive,
  
          Type: 'Old'
        }));
  
        this.IsEdit = true;
        this.IsDisabled = true;
        this.IsUpdate = false;
      });
  }
  onEditConfig() {
      this.IsEdit = false;
      this.IsUpdate = true;
      this.IsDisabled = false;
      // this.IsDisabledAccount = true;
    }
    createEmptyEventRow() {
    return {
      Event_Id: null,
      ProductId: this.ProductId,
      LoginUserId: this.data.userId,
  
      SMS_Step_Id: "",
      WhatsApp_Step_Id: "",
      Mail_Step_Id: "",
  
      IsSMSActive: false,
      IsEmailActive: false,
      IsWhatsAppActive: false,
  
      Type: 'New'
    };
  }
  
  addEventRow() {
    this.EventConfigRows.push(this.createEmptyEventRow());
  }
  removeEventRow(index: number) {
    this.EventConfigRows.splice(index, 1);
  }
  
  
  // saveEventConfig() {
  //   if (!this.EventConfigRows || this.EventConfigRows.length === 0) {
  //     return;
  //   }

  //   // const isEmp = Number(this.Type) === 1;
  //   const type = Number(this.SelectType);
  //   const isEmp = type === 1;
  //   // const isSE = type === 2;

  //   const data = this.EventConfigRows.map(row => ({
  //     Event_Id: Number(row.Event_Id) || 0,

  //     // =========================
  //     // EMP COLUMNS
  //     // =========================

  //     SMS_Step_Id_Emp: isEmp ? Number(row.SMS_Step_Id) || null : null,
  //     Mail_Step_Id_Emp: isEmp ? Number(row.Mail_Step_Id) || null : null,
  //     WhatsApp_Step_Id_Emp: isEmp ? Number(row.WhatsApp_Step_Id) || null : null,

  //     IsSMSActive_Emp: isEmp ? (row.IsSMSActive ? 1 : 0) : null,
  //     IsEmailActive_Emp: isEmp ? (row.IsEmailActive ? 1 : 0) : null,
  //     IsWhatsAppActive_Emp: isEmp ? (row.IsWhatsAppActive ? 1 : 0) : null,
      

  //     // =========================
  //     // SE COLUMNS
  //     // =========================
  //     SMS_Step_Id_SE: !isEmp ? Number(row.SMS_Step_Id) || null : null,
  //     Mail_Step_Id_SE: !isEmp ? Number(row.Mail_Step_Id) || null : null,
  //     WhatsApp_Step_Id_SE: !isEmp ? Number(row.WhatsApp_Step_Id) || null : null,

  //     IsSMSActive_SE: !isEmp ? (row.IsSMSActive ? 1 : 0) : null,
  //     IsEmailActive_SE: !isEmp ? (row.IsEmailActive ? 1 : 0) : null,
  //     IsWhatsAppActive_SE: !isEmp ? (row.IsWhatsAppActive ? 1 : 0) : null,
      
  //     // =========================
  //     // LeadSource COLUMNS
  //     // =========================
  //     SMS_Step_Id_LS: !isEmp ? Number(row.SMS_Step_Id) || null : null,
  //     Mail_Step_Id_LS: !isEmp ? Number(row.Mail_Step_Id) || null : null,
  //     WhatsApp_Step_Id_LS: !isEmp ? Number(row.WhatsApp_Step_Id) || null : null,

  //     IsSMSActive_LS: !isEmp ? (row.IsSMSActive ? 1 : 0) : null,
  //     IsEmailActive_LS: !isEmp ? (row.IsEmailActive ? 1 : 0) : null,
  //     IsWhatsAppActive_LS: !isEmp ? (row.IsWhatsAppActive ? 1 : 0) : null,
      

  //     // =========================
  //     // COMMON FLAGS
  //     // =========================
  //     EventFor: isEmp ? 'Employee' : 'SE',
  //     IsActive: 1,
  //     IsActive_Emp: isEmp ? 1 : null,
  //     IsActive_SE: isEmp ? null : 1
  

  //   }));

  //   const payload = {
  //     JSON: JSON.stringify({ Data: data }),
  //     LoginUserId: Number(this.data.userId)
  //   };
  //   console.log("payload", payload);

  //   this.showSpinner = true;

  //   this.MasterService.Save_Employee_Event_Configuration(payload)
  //     .subscribe(response => {
  //       if (response[0].CODE >= 0) {
  //             this.snackBar.openFromComponent(SnackbarComponent, {
  //               data: response[0].Msg,
  //               ...this.configSuccess,
  //             });
  //               this.showSpinner = false;
  //       this.GetEmployeeEventConfiguration(this.SelectType);
  //       } else
  //         {this.snackBar.openFromComponent(SnackbarComponent, {
  //               data: response[0].Msg,
  //               ...this.configSuccess,
  //             });}
  //     });
  // }
  saveEventConfig() {
  if (!this.EventConfigRows || this.EventConfigRows.length === 0) {
    return;
  }

  const type = Number(this.SelectType);
  const isEmp = type === 1;
  const isSE = type === 0;
  const isLS = type === 2;

  const data = this.EventConfigRows.map(row => ({
    Event_Id: Number(row.Event_Id) || 0,

    // =========================
    // EMP COLUMNS
    // =========================
    SMS_Step_Id_Emp: isEmp ? Number(row.SMS_Step_Id) || null : null,
    Mail_Step_Id_Emp: isEmp ? Number(row.Mail_Step_Id) || null : null,
    WhatsApp_Step_Id_Emp: isEmp ? Number(row.WhatsApp_Step_Id) || null : null,

    IsSMSActive_Emp: isEmp ? (row.IsSMSActive ? 1 : 0) : null,
    IsEmailActive_Emp: isEmp ? (row.IsEmailActive ? 1 : 0) : null,
    IsWhatsAppActive_Emp: isEmp ? (row.IsWhatsAppActive ? 1 : 0) : null,

    // =========================
    // SE COLUMNS
    // =========================
    SMS_Step_Id_SE: isSE ? Number(row.SMS_Step_Id) || null : null,
    Mail_Step_Id_SE: isSE ? Number(row.Mail_Step_Id) || null : null,
    WhatsApp_Step_Id_SE: isSE ? Number(row.WhatsApp_Step_Id) || null : null,

    IsSMSActive_SE: isSE ? (row.IsSMSActive ? 1 : 0) : null,
    IsEmailActive_SE: isSE ? (row.IsEmailActive ? 1 : 0) : null,
    IsWhatsAppActive_SE: isSE ? (row.IsWhatsAppActive ? 1 : 0) : null,

    // =========================
    // LEAD SOURCE COLUMNS
    // =========================
    SMS_Step_Id_LS: isLS ? Number(row.SMS_Step_Id) || null : null,
    Mail_Step_Id_LS: isLS ? Number(row.Mail_Step_Id) || null : null,
    WhatsApp_Step_Id_LS: isLS ? Number(row.WhatsApp_Step_Id) || null : null,

    IsSMSActive_LS: isLS ? (row.IsSMSActive ? 1 : 0) : null,
    IsEmailActive_LS: isLS ? (row.IsEmailActive ? 1 : 0) : null,
    IsWhatsAppActive_LS: isLS ? (row.IsWhatsAppActive ? 1 : 0) : null,

    // =========================
    // COMMON FLAGS & EVENT FOR
    // =========================
    EventFor: isEmp ? 'Employee' : (isSE ? 'SE' : 'LeadSource'),
    IsActive: 1,
    IsActive_Emp: isEmp ? 1 : null,
    IsActive_SE: isSE ? 1 : null,
    IsActive_LS: isLS ? 1 : null

  }));

  const payload = {
    JSON: JSON.stringify({ Data: data }),
    LoginUserId: Number(this.data.userId)
  };
  
  console.log("payload", payload);

  this.showSpinner = true;

  this.MasterService.Save_Employee_Event_Configuration(payload)
    .subscribe(response => {
      if (response[0].CODE >= 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: response[0].Msg,
          ...this.configSuccess,
        });
        this.showSpinner = false;
        this.GetEmployeeEventConfiguration(this.SelectType);
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: response[0].Msg,
          ...this.configSuccess,
        });
        this.showSpinner = false;
      }
    }, error => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: 'Error occurred while saving configuration',
        ...this.configSuccess,
      });
      this.showSpinner = false;
    });
}

  
  canAddRow(row: any): boolean {
    if (!row) {
      return false;
    }
  
    const eventSelected = !!row.Event_Id;
  
    const atLeastOneTemplateSelected =
      !!row.SMS_Step_Id ||
      !!row.Mail_Step_Id ||
      !!row.WhatsApp_Step_Id;
  
    return eventSelected && atLeastOneTemplateSelected;
  }
  getSelectedEventIds(excludeIndex?: number): number[] {
    return this.EventConfigRows
      .filter((_, i) => i !== excludeIndex)
      .map(r => Number(r.Event_Id))
      .filter(id => id > 0);
  }
  onMailTemplateChange(row: any) {
    if (!row.Mail_Step_Id) {
      row.IsEmailActive = false;
    }
  }

  onSmsTemplateChange(row: any) {
    if (!row.SMS_Step_Id) {
      row.IsSMSActive = false;
    }
  }

  onWaTemplateChange(row: any) {
    if (!row.WhatsApp_Step_Id) {
      row.IsWhatsAppActive = false;
    }
  }

}
